import { render } from "./CatePage.vue?vue&type=template&id=6eabb636"
import script from "./CatePage.vue?vue&type=script&lang=js"
export * from "./CatePage.vue?vue&type=script&lang=js"

import "./CatePage.vue?vue&type=style&index=0&id=6eabb636&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__